import { UPDATE_AGENT_PROFILE } from "../actions/types";

const initialState = {
  country: "",
  state: "",
  city: "",
  website: "",
  facebook: "",
  youtube: "",
  twitter: "",
  instagram: "",
  agencyName: "",
  hotelRooms: false,
  food: false,
  sightSeeing: false,
  carHire: false,
  airTicket: false,
  trainTicket: false,
  busTicket: false,
  others: false,
  otherServices: "",
  languages: "",
  address: "",
  serviceAreas: "",
};

function agentProfileReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case UPDATE_AGENT_PROFILE:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
}

export default agentProfileReducer;
